import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./reducers";
import createSagaMiddleware from "redux-saga";
import rootSaga from "./sagas";
import { composeWithDevToolsDevelopmentOnly } from "@redux-devtools/extension";

const sagaMiddleware = createSagaMiddleware();

export default function setupReduxStore() {
  const store = createStore(
    rootReducer,
    composeWithDevToolsDevelopmentOnly(compose(applyMiddleware(sagaMiddleware)))
  );
  sagaMiddleware.run(rootSaga);

  return store;
}
